import { render } from "./IntroTextCenter.vue?vue&type=template&id=54ff25a2"
import script from "./IntroTextCenter.vue?vue&type=script&lang=js"
export * from "./IntroTextCenter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__